<template>
  <div>
    <v-data-table
      :key="tableKey"
      v-model="selectedStudents"
      :headers="headers"
      :items="students"
      item-key="id"
      showSelect
      disable-pagination
      hide-default-footer
      :loading="loading"
      loading-text="Đang Tải"
      no-data-text="Không có học sinh"
    >
      <template #top>
        <div class="d-flex justify-space-between align-start px-4 pt-4 pb-3">
          <div class="d-flex flex-column align-start">
            <v-btn height="40" color="primary" @click="handleEditGroup"> Nhận xét nhóm </v-btn>
            <div v-if="selectedStudents.length" class="mt-2">
              <span class="text-subtitle-2 font-weight-bold text--primary">
                Đã chọn {{ selectedStudents.length }} học sinh
              </span>
            </div>
          </div>
          <div class="d-flex align-center">
            <v-btn height="40" color="primary" class="mr-2" @click="handleDraftPost"> Soạn tin </v-btn>
            <v-btn height="40" color="success" class="white--text" @click="handleSendPost"> Gửi tin </v-btn>
          </div>
        </div>
      </template>

      <template #item.index="{ index }">
        {{ index + 1 }}
      </template>
      <template #item.name="{ item }">
        <div class="d-flex align-center" style="white-space: nowrap">
          <span class="font-weight-medium">{{ item.name }}</span>
          <span v-if="item.dob || item.code" class="mx-1">-</span>
          <span v-if="item.dob">{{ item.dob | ddmm }}</span>
          <span v-if="item.dob && item.code" class="mx-1">-</span>
          <span v-if="item.code">{{ item.code }}</span>
        </div>
      </template>
      <template #item.comment="{ item }">
        <div @click="editItem(item, 0)" style="cursor: pointer; min-height: 24px; min-width: 100px">
          <span v-if="item.comment">{{ item.comment }}</span>
          <span v-else class="grey--text">Chưa có nhận xét</span>
        </div>
      </template>
      <template #item.additionalComment="{ item }">
        <div @click="editItem(item, 0)" style="cursor: pointer; min-height: 24px; min-width: 100px">
          <span v-if="item.additionalComment">{{ item.additionalComment }}</span>
          <span v-else class="grey--text">Chưa có nhận xét bổ sung</span>
        </div>
      </template>
      <template #item.messageContent="{ item }">
        <div @click="editItem(item, 1)" style="cursor: pointer; min-height: 24px; min-width: 100px">
          <span v-if="item.messageContent">{{ item.messageContent }}</span>
          <span v-else class="grey--text">Chưa có nội dung</span>
        </div>
      </template>
      <template #item.actions="{ item }">
        <v-btn icon small color="primary" @click="editItem(item, 0)">
          <v-icon small>edit</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="700px" scrollable>
      <v-card>
        <v-card-title class="primary white--text text-uppercase d-flex align-center py-3 px-4">
          <span>Đánh giá học sinh</span>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-tabs
          v-if="!isGroupEdit"
          v-model="activeTab"
          grow
          background-color="grey lighten-4"
          color="primary"
          slider-color="primary"
        >
          <v-tab class="font-weight-bold">
            <v-icon left small>mdi-comment-account-outline</v-icon>
            Nhận xét học sinh
          </v-tab>
          <v-tab class="font-weight-bold">
            <v-icon left small>mdi-message-text-outline</v-icon>
            Nội dung tin nhắn
          </v-tab>
        </v-tabs>
        <v-divider />

        <v-card-text class="py-4" style="max-height: 500px; min-height: 380px">
          <v-form ref="form" @submit.prevent="save">
            <!-- Nhận xét nhóm: Hiển thị form mẫu nhận xét và nhận xét bổ sung trực tiếp -->
            <div v-if="isGroupEdit">
              <div class="subtitle-1 font-weight-bold mb-2">Mẫu Nhận xét</div>
              <v-divider></v-divider>
              <div class="mt-2 pr-1" style="max-height: 250px; overflow-y: auto">
                <v-checkbox
                  v-for="item in commentTemplates"
                  :key="item.id"
                  v-model="editedItem.selectedTemplates"
                  :value="item.id"
                  :label="`${item.id}. ${item.text}`"
                  dense
                  hide-details
                  class="mt-1"
                ></v-checkbox>
              </div>
              <v-divider class="my-3"></v-divider>
              <div class="subtitle-1 font-weight-bold mb-2">Nhận xét bổ sung</div>
              <v-textarea
                v-model="editedItem.additionalComment"
                rows="3"
                outlined
                dense
                placeholder="Nhập nhận xét bổ sung..."
                @keydown.tab="handleTabExpander($event, 'additionalComment')"
              ></v-textarea>
              <div class="caption grey--text text--darken-2">
                Có thể nhập tắt nội dung bằng cách: "Số"+"Tab" ví dụ: 1 + "Tab" -> Con nghỉ học có phép
              </div>
            </div>

            <!-- Sửa từng học sinh: Hiển thị 2 Tabs -->
            <v-tabs-items v-else v-model="activeTab">
              <!-- Tab 1: Nhận xét học sinh -->
              <v-tab-item>
                <div class="subtitle-1 font-weight-bold mb-2">Mẫu Nhận xét</div>
                <v-divider></v-divider>
                <div class="mt-2 pr-1" style="max-height: 250px; overflow-y: auto">
                  <v-checkbox
                    v-for="item in commentTemplates"
                    :key="item.id"
                    v-model="editedItem.selectedTemplates"
                    :value="item.id"
                    :label="`${item.id}. ${item.text}`"
                    dense
                    hide-details
                    class="mt-1"
                  ></v-checkbox>
                </div>
                <v-divider class="my-3"></v-divider>
                <div class="subtitle-1 font-weight-bold mb-2">Nhận xét bổ sung</div>
                <v-textarea
                  v-model="editedItem.additionalComment"
                  rows="3"
                  outlined
                  dense
                  placeholder="Nhập nhận xét bổ sung..."
                  @keydown.tab="handleTabExpander($event, 'additionalComment')"
                ></v-textarea>
                <div class="caption grey--text text--darken-2">
                  Có thể nhập tắt nội dung bằng cách: "Số"+"Tab" ví dụ: 1 + "Tab" -> Con nghỉ học có phép
                </div>
              </v-tab-item>

              <!-- Tab 2: Nội dung tin nhắn -->
              <v-tab-item>
                <div class="subtitle-1 font-weight-bold mb-2">Nội dung tin nhắn</div>
                <v-divider class="mb-3"></v-divider>
                <v-textarea
                  v-model="editedItem.messageContent"
                  rows="10"
                  outlined
                  dense
                  placeholder="Nhập nội dung tin nhắn..."
                  @keydown.tab="handleTabExpander($event, 'messageContent')"
                ></v-textarea>
                <div class="caption grey--text text--darken-2">
                  Có thể nhập tắt nội dung bằng cách: "Số"+"Tab" ví dụ: 1 + "Tab" -> Con nghỉ học có phép
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
          <v-btn class="px-4" outlined light depressed @click="close">HỦY</v-btn>
          <v-spacer></v-spacer>
          <span class="text-body-2 font-weight-medium mr-4" v-if="isGroupEdit">
            Thông báo : Sẽ thiết lập đánh giá nhận xét cho {{ selectedStudents.length }} học sinh
          </span>
          <v-btn class="px-6" dark depressed color="primary" @click="save" :loading="isSaving">LƯU</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDialog" max-width="450px">
      <v-card>
        <v-card-title class="headline">Xác nhận gửi tin nhắn</v-card-title>
        <v-card-text>
          Bạn có chắc chắn muốn gửi tin nhắn cho {{ selectedStudents.length }} học sinh đã chọn không?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="confirmDialog = false">Hủy</v-btn>
          <v-btn color="primary" @click="confirmSend" :loading="isSendingAll">Đồng ý</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { ContactBook } from '@/plugins/api'

const defaultHeaders = [
  { text: 'STT', value: 'index', align: 'left', sortable: false },
  { text: 'Tên học sinh', value: 'name', align: 'left', sortable: false },
  { text: 'Nhận xét', value: 'comment', align: 'left', sortable: false },
  { text: 'Nhận xét bổ sung', value: 'additionalComment', align: 'left', sortable: false },
  { text: 'Nội dung tin nhắn', value: 'messageContent', align: 'left', sortable: false },
  { text: 'Thao tác', value: 'actions', align: 'center', sortable: false, width: '100px' }
]

export default {
  components: { CardStudentName },
  data() {
    return {
      tableKey: 0,
      headers: defaultHeaders,
      selectedStudents: [],
      loading: false,
      studentSearchParams: {},
      dialog: false,
      activeTab: 0,
      confirmDialog: false,
      isSaving: false,
      isSendingAll: false,
      editedIndex: -1,
      isGroupEdit: false,
      commentTemplates: [
        { id: '1', text: 'Con nghỉ học có phép', ktklType: 'violation' },
        { id: '2', text: 'Con nghỉ học không phép, đề nghị PH lần sau xin phép cho con', ktklType: 'violation' },
        { id: '3', text: 'Con đi học muộn', ktklType: 'violation' },
        { id: '4', text: 'Con nghỉ tiết không lý do', ktklType: 'violation' },
        { id: '5', text: 'Con không mặc đúng đồng phục quy định', ktklType: 'violation' },
        { id: '6', text: 'Con thiếu sách vở dụng cụ học tập', ktklType: 'violation' },
        { id: '7', text: 'Con làm thiếu bài tập về nhà', ktklType: 'violation' },
        { id: '8', text: 'Con không học bài cũ', ktklType: 'violation' },
        { id: '9', text: 'Con còn nói chuyện riêng trong giờ học', ktklType: 'violation' },
        { id: '10', text: 'Con chưa chú ý nghe giảng, mải chơi', ktklType: 'violation' },
        { id: '11', text: 'Gia đình kiểm tra bài học, bài làm của học sinh trước khi đến lớp', ktklType: 'violation' },
        { id: '12', text: 'Gia đình giúp con ôn tập lại bài trên lớp', ktklType: 'violation' },
        { id: '13', text: 'Con bị điểm kém, gia đình kèm con làm lại bài tập ngày hôm nay', ktklType: 'violation' },
        { id: '14', text: 'Đề nghị gia đình ký vào bài kiểm tra của các con', ktklType: 'violation' },
        { id: '15', text: 'Con không viết đủ bài. PH xem và ký vào vở của con', ktklType: 'violation' },
        { id: '16', text: 'Con sử dụng điện thoại trong giờ', ktklType: 'violation' },
        { id: '71', text: 'Con làm thiếu BT môn Toán', ktklType: 'violation' },
        { id: '72', text: 'Con làm thiếu BT môn Văn', ktklType: 'violation' },
        { id: '73', text: 'Con làm thiếu BT môn Anh', ktklType: 'violation' },
        { id: '81', text: 'Con không học bài cũ môn Toán', ktklType: 'violation' },
        { id: '82', text: 'Con không học bài cũ môn Văn', ktklType: 'violation' },
        { id: '83', text: 'Con không học bài cũ môn Anh', ktklType: 'violation' }
      ],
      editedItem: {
        selectedTemplates: [],
        additionalComment: '',
        messageContent: ''
      }
    }
  },
  computed: {
    ...mapState('students', ['students']),
    hasDraftedMessages() {
      return (
        this.selectedStudents.length > 0 &&
        this.selectedStudents.every(
          s =>
            (s.comment && s.comment.trim()) ||
            (s.additionalComment && s.additionalComment.trim()) ||
            (s.messageContent && s.messageContent.trim())
        )
      )
    },
    isTemplateSelected() {
      return !!(this.editedItem.selectedTemplates && this.editedItem.selectedTemplates.length > 0)
    }
  },
  watch: {
    'editedItem.selectedTemplates'(newVal) {
      if (newVal && newVal.length > 0 && this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    }
  },
  methods: {
    ...mapActions('students', ['getManyStudents']),
    handleTabExpander(e, field) {
      const el = e.target
      const val = this.editedItem[field] || ''
      const pos = el.selectionStart
      if (pos === undefined) return

      const beforeCursor = val.substring(0, pos)
      const afterCursor = val.substring(pos)

      const match = beforeCursor.match(/(\d+)$/)
      if (match) {
        const id = match[1]
        const template = this.commentTemplates.find(t => t.id === id)
        if (template) {
          e.preventDefault()
          let replaceText = template.text
          let textBeforeId = beforeCursor.slice(0, -id.length)

          if (textBeforeId.trim().length > 0) {
            replaceText = replaceText.replace(/^[Cc]on\s+/, '')
            const trimmedBefore = textBeforeId.trimEnd()
            if (trimmedBefore.endsWith(',') || trimmedBefore.endsWith('.')) {
              textBeforeId = trimmedBefore + ' '
            } else {
              textBeforeId = trimmedBefore + ', '
            }
          }

          const newBeforeCursor = textBeforeId + replaceText
          this.editedItem[field] = newBeforeCursor + afterCursor
          this.$nextTick(() => {
            el.selectionStart = el.selectionEnd = newBeforeCursor.length
          })
        }
      }
    },
    async searchStudents(studentFilters) {
      this.loading = true
      if (studentFilters) {
        this.selectedStudents = []
        this.studentSearchParams = { ...studentFilters, _limit: 9999 } // Fetch all instead of paginating
      }
      try {
        await this.getManyStudents({ searchParams: this.studentSearchParams })

        // Map evaluation data từ DB vào các field hiển thị trên UI
        this.students.forEach(student => {
          if (student.evaluation) {
            // Vue reactivity requires using this.$set or modifying the object directly
            // Since this.students is an array of objects, modifying properties directly usually works if they are pre-defined,
            // but to be safe we can use Vue.set or Object.assign if they aren't reactive yet.
            student.comment = student.evaluation.comment || ''
            student.additionalComment = student.evaluation.additionalComment || ''
            student.messageContent = student.evaluation.messageContent || ''
            student.selectedTemplates = student.evaluation.selectedTemplates || []
          }
        })
      } catch (error) {
        this.$alert.error('Không lấy được danh sách học sinh. Lỗi : ', error)
      }
      this.loading = false
    },
    getCommentText(templateIds) {
      if (!templateIds || !templateIds.length) return ''
      return (
        templateIds
          .slice()
          .sort((a, b) => a - b)
          .map(id => {
            const template = this.commentTemplates.find(t => t.id === id)
            return template ? template.text : ''
          })
          .filter(Boolean)
          .join('. ') + '.'
      )
    },
    getKtklType(selectedTemplates, additionalComment) {
      if (!selectedTemplates || selectedTemplates.length === 0) {
        if (additionalComment) {
          const lowerComment = additionalComment.toLowerCase()
          if (
            lowerComment.includes('tốt') ||
            lowerComment.includes('ngoan') ||
            lowerComment.includes('hăng hái') ||
            lowerComment.includes('khen') ||
            lowerComment.includes('tuyên dương') ||
            lowerComment.includes('xuất sắc')
          ) {
            return 'commendation'
          }
          return 'violation'
        }
        return null
      }

      let hasViolation = false
      let hasCommendation = false

      selectedTemplates.forEach(id => {
        const template = this.commentTemplates.find(t => t.id === id)
        if (template) {
          if (template.ktklType === 'violation') hasViolation = true
          if (template.ktklType === 'commendation') hasCommendation = true
        }
      })

      if (hasViolation) return 'violation'
      if (hasCommendation) return 'commendation'
      return null
    },
    editItem(item, initialTab = 0) {
      this.isGroupEdit = false
      this.activeTab = initialTab
      this.editedIndex = this.students.indexOf(item)
      this.editedItem = {
        selectedTemplates: item.selectedTemplates ? [...item.selectedTemplates] : [],
        additionalComment: item.additionalComment || '',
        messageContent: item.messageContent || ''
      }
      this.dialog = true
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      })
    },
    editGroup(initialTab = 0) {
      this.isGroupEdit = true
      this.activeTab = initialTab
      this.editedItem = {
        selectedTemplates: [],
        additionalComment: '',
        messageContent: ''
      }
      this.dialog = true
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      })
    },
    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = { selectedTemplates: [], additionalComment: '', messageContent: '' }
        this.editedIndex = -1
        this.activeTab = 0
        this.isGroupEdit = false
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      })
    },
    async save() {
      let studentsToUpdate = []

      if (this.isGroupEdit) {
        const hasTemplates = this.editedItem.selectedTemplates && this.editedItem.selectedTemplates.length > 0
        const hasAdditionalComment =
          this.editedItem.additionalComment && this.editedItem.additionalComment.trim().length > 0

        if (!hasTemplates && !hasAdditionalComment) {
          this.$alert.error('Vui lòng chọn ít nhất một mẫu nhận xét hoặc nhập nhận xét bổ sung!')
          return
        }

        this.selectedStudents.forEach(student => {
          const index = this.students.indexOf(student)
          if (index > -1) {
            const commentText = this.getCommentText(this.editedItem.selectedTemplates)
            const updatedStudent = Object.assign({}, this.students[index], {
              selectedTemplates: [...this.editedItem.selectedTemplates],
              comment: commentText,
              additionalComment: this.editedItem.additionalComment,
              messageContent: this.students[index].messageContent || ''
            })
            this.$set(this.students, index, updatedStudent)
            studentsToUpdate.push(this.students[index])
          }
        })
      } else {
        const hasTemplates = this.editedItem.selectedTemplates && this.editedItem.selectedTemplates.length > 0
        const hasAdditionalComment =
          this.editedItem.additionalComment && this.editedItem.additionalComment.trim().length > 0
        const hasMessageContent = this.editedItem.messageContent && this.editedItem.messageContent.trim().length > 0

        if (!hasTemplates && !hasAdditionalComment && !hasMessageContent) {
          this.$alert.error('Vui lòng chọn mẫu nhận xét, nhập nhận xét bổ sung hoặc nhập nội dung tin nhắn!')
          return
        }

        if (this.editedIndex > -1) {
          const commentText = this.getCommentText(this.editedItem.selectedTemplates)
          const updatedStudent = Object.assign({}, this.students[this.editedIndex], {
            selectedTemplates: [...this.editedItem.selectedTemplates],
            comment: commentText,
            additionalComment: this.editedItem.additionalComment,
            messageContent: this.editedItem.messageContent
          })
          this.$set(this.students, this.editedIndex, updatedStudent)
          studentsToUpdate.push(this.students[this.editedIndex])
        }
      }

      if (studentsToUpdate.length > 0) {
        this.isSaving = true
        try {
          const optimizedStudents = studentsToUpdate.map(s => ({
            _id: s._id || s.id,
            comment: s.comment,
            additionalComment: s.additionalComment,
            messageContent: s.messageContent || '',
            selectedTemplates: s.selectedTemplates,
            ktklType: this.getKtklType(s.selectedTemplates, s.additionalComment)
          }))
          await ContactBook.sendStudentEvaluation({ students: optimizedStudents, title: 'Thông báo đánh giá học sinh' })
          this.$alert.success('Đã lưu đánh giá thành công!')
          this.close()
        } catch (error) {
          const errorMessage = (error.response && error.response.data && error.response.data.message) || error.message
          this.$alert.error('Lỗi khi lưu đánh giá: ' + errorMessage)
        } finally {
          this.isSaving = false
        }
      } else {
        this.close()
      }
    },
    updateMessageContents(posts) {
      if (!posts || !posts.length) return
      posts.forEach(post => {
        const studentRow = this.students.find(s => (s._id || s.id) === post.student)
        if (studentRow) {
          this.$set(studentRow, 'messageContent', post.content)
        }
      })
      this.tableKey += 1
    },
    openConfirmSend() {
      this.confirmDialog = true
    },
    checkSelectedStudents() {
      if (!this.selectedStudents || !this.selectedStudents.length) {
        this.$alert.warn('Bạn chưa chọn học sinh nào, vui lòng chọn ít nhất 1 học sinh')
        return false
      }
      return true
    },
    handleEditGroup() {
      if (!this.checkSelectedStudents()) return
      this.editGroup()
    },
    handleDraftPost() {
      if (!this.checkSelectedStudents()) return
      this.$emit('sendPost', { students: this.selectedStudents })
    },
    handleSendPost() {
      if (!this.checkSelectedStudents()) return
      this.openConfirmSend()
    },
    async confirmSend() {
      this.isSendingAll = true
      try {
        const optimizedStudents = this.selectedStudents.map(s => ({
          _id: s._id || s.id,
          comment: s.comment,
          additionalComment: s.additionalComment,
          messageContent: s.messageContent || '',
          selectedTemplates: s.selectedTemplates,
          ktklType: this.getKtklType(s.selectedTemplates, s.additionalComment)
        }))
        await ContactBook.sendStudentEvaluation({ students: optimizedStudents, title: 'Thông báo đánh giá học sinh' })
        this.$alert.success('Đã gửi tin nhắn thành công cho ' + this.selectedStudents.length + ' học sinh!')
        this.confirmDialog = false
        this.selectedStudents = []
      } catch (error) {
        const errorMessage = (error.response && error.response.data && error.response.data.message) || error.message
        this.$alert.error('Lỗi khi gửi tin nhắn: ' + errorMessage)
      } finally {
        this.isSendingAll = false
      }
    }
  }
}
</script>
